/**
 *
 * Asset2
 *
 */
import React, { memo } from 'react';
import styled from 'styled-components/macro';
import { useTranslation } from 'react-i18next';
import { messages } from './messages';
import { AssetDistribution } from 'app/components/AssetDistribution';
import { TrackAssets } from 'app/components/TrackAssets/Loadable';
import { Networth_Image } from 'constants/constants';
import { media } from 'styles/media';
import { useNetworth } from 'app/Provider/NetworthProvider';

interface Props {}
interface TextColor {
  color?: string;
  value?: string;
}
export const Asset2 = memo((props: Props) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { t, i18n } = useTranslation();
  const { login } = useNetworth();
  const totalAsset = login ? '₹ 52,000.00' : '₹ 0.00';
  const totalAsset2 = login ? '₹ 66,000.00' : '₹ 0.00';
  const totalGain = login ? '+₹ 14,000.00' : '₹ 0.00';
  const todayChange = login ? '+₹ 357 (0.73%)' : '₹ 0.00';
  const annualReturn = login ? '56.26%' : '0.00%';
  return (
    <Container>
      <Card>
        <Div className="d-flex flex-column gap-4 p-xl-3 px-md-3 px-2 py-4 w-100 ">
          <div className="d-flex gap-3">
            <Wrapper className="border rounded-4 ">
              <div
                className="d-flex justify-content-between "
                style={{ justifyItems: 'center', alignItems: 'center' }}
              >
                <Text className="m-3">{t(messages.name())}</Text>
                <img
                  className="m-3 image-fluid"
                  src={Networth_Image}
                  alt="not-found"
                />
              </div>
              <Divider></Divider>
              <OuterDiv className="mt-3 d-flex flex-wrap gap-3">
                <InnerDiv className=" ms-3">
                  <TextSmall>{t(messages.totalAsset())}</TextSmall>
                  <Textmed value={totalAsset}>{totalAsset}</Textmed>
                </InnerDiv>
                <InnerDiv>
                  <TextSmall>{t(messages.totalAsset())}</TextSmall>
                  <Textmed value={totalAsset2}>{totalAsset2}</Textmed>
                </InnerDiv>
                <InnerDiv>
                  <TextSmall>{t(messages.totalGain())}</TextSmall>
                  <Textmed color="#27ABC0" value={totalGain}>
                    {totalGain}
                  </Textmed>
                </InnerDiv>
                <InnerDiv>
                  <TextSmall>{t(messages.todayChange())}</TextSmall>
                  <Textmed color="#27ABC0" value={todayChange}>
                    {todayChange}
                  </Textmed>
                </InnerDiv>
                <div>
                  <TextSmall>{t(messages.annualReturn())}</TextSmall>
                  <Textmed color="#27ABC0" value={annualReturn}>
                    {annualReturn}
                  </Textmed>
                </div>
              </OuterDiv>
            </Wrapper>
            <ScaleDiv className="border">
              <div className="p-3 d-flex justify-content-between align-items-center">
                <h6>Asset diversification score</h6>
                <img
                  className="image-fluid"
                  src={Networth_Image}
                  alt="not-found"
                />
              </div>
              <Divider></Divider>
              <div className="d-flex flex-column justify-content-center align-items-center">
                <div className="d-flex flex-column justify-content-center align-items-center">
                  <UserScoreDiv className="mt-3">
                    <TextScale> Your score : 58</TextScale>
                  </UserScoreDiv>
                  <div
                    style={{
                      height: '20px',
                      width: '1px',
                      border: '1px dashed #AF8EFF',
                    }}
                  ></div>
                </div>
                <div className="d-flex flex-column justify-content-center align-items-center">
                  <UserScoreDiv className="ms-5">
                    <TextScale> Avg score : 65</TextScale>
                  </UserScoreDiv>
                  <div className="ms-5" style={{ width: '48px' }}>
                    <span
                      style={{
                        height: '20px',
                        border: '1px dashed #AF8EFF',
                      }}
                    ></span>
                    <BlackLine></BlackLine>
                  </div>
                </div>

                <ResultDiv>
                  <UserPoint></UserPoint>
                  <AveragePoint></AveragePoint>
                </ResultDiv>
                <div className="d-flex  p-3 w-100 justify-content-between">
                  <h6>Concentrated</h6>
                  <h6>Diversified</h6>
                </div>
              </div>
            </ScaleDiv>
          </div>
          <AssetDistribution />
          <TrackAssets />
        </Div>
      </Card>
    </Container>
  );
});
const TextScale = styled.span`
  font-weight: 700;
  font-size: 12px;
`;
const BlackLine = styled.span`
  height: 20px;
  width: 1px;
  border: 1px dashed black;
  margin-left: 32px;
  @media (min-width: 1500px) {
    margin-left: 34px;
  }
`;
const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex: 1;
  position: relative;
  overflow: hidden;
`;
const Card = styled.div<{ right?: boolean }>`
  //////
  flex-grow: 1;
  overflow-y: auto;
  transition: max-height 0.3s ease-in-out;
  ::-webkit-scrollbar {
    width: 0px; /* Width of the scrollbar */
  }

  ::-webkit-scrollbar-thumb {
    background-color: transparent; /* Color of the thumb */
    border-radius: 15px; /* Rounded corners */
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #e4dfff; /* Color of thumb when hovered */
  }

  ::-webkit-scrollbar-track {
    background-color: transparent; /* Background color of the track */
    border-radius: 15px; /* Rounded corners of the track */
  }

  ::-webkit-scrollbar-corner {
    background-color: #e4dfff; /* Corner of the scrollbar */
  }
`;
const ResultDiv = styled.div`
  position: relative;
  width: 90%;
  background: linear-gradient(to right, #ff7b6a, #ffd707, #27abc0);
  height: 13px;
  border-radius: 50px;
`;
const UserScoreDiv = styled.div`
  height: 28px;
  width: 115px;
  border-radius: 8px;
  text-align: center;
  background-color: #f3f1fe;
`;
const UserPoint = styled.div`
  position: absolute;
  height: 15px;
  width: 15px;
  top: 0%;
  left: 48%;
  border-radius: 50%;
  background-color: #8276f4;
`;
const AveragePoint = styled.div`
  position: absolute;
  height: 15px;
  width: 15px;
  top: 0%;
  left: 58%;
  border-radius: 50%;
  background-color: black;
`;

const Div = styled.div`
  background-color: #f5f6fa;
`;
const Textmed = styled.h6<TextColor>`
  font-weight: 800;
  font-size: 20px;
  color: ${({ color, value }) =>
    value === '₹ 0.00' || value === '0.00%' ? '#C8CCD8' : color || 'black'};
`;
const ScaleDiv = styled.div`
  width: 600px;
  height: 250px;
  background-color: #ffffff;
  border-radius: 20px;
`;
const Wrapper = styled.div`
  background-color: white;
  width: 100%;
  height: 250px;
  margin: auto;
  border-radius: 10px;

  @media (max-width: 900px) {
    height: auto;
  }
  ${media.medium} {
    width: 70vw;
  }
  ${media.small} {
    width: 90vw;
  }
`;
const TextSmall = styled.h6`
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  color: #c8ccd8;
`;

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #f3f1fe;
`;
const OuterDiv = styled.div`
  > :first-child {
    width: 30%;
  }
  > :nth-child(2) {
    width: 30%;
  }
  > :nth-child(3) {
    width: 30%;
  }
  > :nth-child(4) {
    width: 30%;
    margin-left: 10px;
  }
  > :last-child {
    width: 30%;
  }
`;
const InnerDiv = styled.div``;
const Text = styled.div`
  font-size: 16px;
  font-weight: 600;
`;
